export default __webpack_public_path__ + "1548373628c04aaef16c5c8c20ebeaf3.png";